'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { parseApiAsset } from '@morpho-org/dapp-core';
import { useMemo } from 'react';
import { getParsedValue } from '@/helpers/formatters';
import { toInterfaceInputToken } from '@/helpers/interfaceToken';
import type { LiquidationTableDataRow } from '../config/LiquidationTable.types';
import type { MarketLiquidation } from '../liquidations.contract';
const useLiquidationTableRow = t0 => {
  const $ = _c(6);
  const {
    transactions,
    chainId
  } = t0;
  let t1;
  bb0: {
    if (!transactions) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== chainId || $[2] !== transactions) {
      let t3;
      if ($[4] !== chainId) {
        t3 = tx => ({
          chainId,
          loanAsset: parseApiAsset(toInterfaceInputToken(tx.loanAsset, chainId)),
          collateralAsset: parseApiAsset(toInterfaceInputToken(tx.collateralAsset, chainId)),
          date: {
            timestamp: BigInt(tx.timestamp)
          },
          liquidated: {
            address: tx.borrowerAddress
          },
          liquidator: {
            address: tx.liquidatorAddress
          },
          tx: {
            hash: tx.txHash
          },
          collateralSeized: {
            amount: BigInt(tx.seizedAssets),
            amountUsd: getParsedValue(tx.seizedAssetsUsd, safeParseNumber)
          },
          loanRepaid: {
            amount: BigInt(tx.repaidAssets),
            amountUsd: getParsedValue(tx.repaidAssetsUsd, safeParseNumber)
          },
          realizedBadDebt: {
            amount: BigInt(tx.badDebtAssets),
            amountUsd: getParsedValue(tx.badDebtAssetsUsd, safeParseNumber)
          }
        });
        $[4] = chainId;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = transactions.map(t3);
      $[1] = chainId;
      $[2] = transactions;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  return t1;
};
export default useLiquidationTableRow;